export const FETCH_ADDRESSESS_REQUEST = "FETCH_ADDRESSESS_REQUEST";
export const FETCH_ADDRESSESS_FAIL = "FETCH_ADDRESSESS_FAIL";
export const FETCH_ADDRESSESS_SUCCESS = "FETCH_ADDRESSESS_SUCCESS";
export const CREATE_PROPERTY_REQUEST = "CREATE_PROPERTY_REQUEST";
export const CREATE_PROPERTY_SUCCESS = "CREATE_PROPERTY_SUCCESS";
export const CREATE_PROPERTY_FAIL = "CREATE_PROPERTY_FAIL";
export const GET_ALL_LISTING_REQUEST = "GET_ALL_LISTING_REQUEST";
export const GET_ALL_LISTING_SUCCESS = "GET_ALL_SUCCESS";
export const GET_ALL_LISTING_FAIL = "GET_ALL_LISTING_FAIL";
export const GET_SINGLE_PROPERTY_REQUEST = "GET_SINGLE_PROPERTY_REQUEST";
export const GET_SINGLE_PROPERTY_SUCCESS = "GET_SINGLE_PROPERTY_SUCCESS";
export const GET_SINGLE_PROPERTY_FAIL = "GET_SINGLE_PROPERTY_FAIL";
export const INVITE_TENANTS_REQUEST = "INVITE_TENANTS_REQUEST";
export const INVITE_TENANTS_SUCCESS = "INVITE_TENANTS_SUCCESS";
export const INVITE_TENANTS_FAIL = "INVITE_TENANTS_FAIL";
export const SEND_CREATE_ACCOUNT_REMINDER_REQUEST = "SEND_CREATE_ACCOUNT_REMINDER_REQUEST";
export const SEND_CREATE_ACCOUNT_REMINDER_SUCCESS = "SEND_CREATE_ACCOUNT_REMINDER_SUCCESS";
export const SEND_CREATE_ACCOUNT_REMINDER_FAIL = "SEND_CREATE_ACCOUNT_REMINDER_FAIL";
export const DELETE_TENANTS_FROM_PROPERTY_REQUEST = "DELETE_TENANTS_FROM_PROPERTY_REQUEST";
export const DELETE_TENANTS_FROM_PROPERTY_SUCCESS = "DELETE_TENANTS_FROM_PROPERTY_SUCCESS";
export const DELETE_TENANTS_FROM_PROPERTY_FAIL = "DELETE_TENANTS_FROM_PROPERTY_FAIL";
export const UPDATE_TENANCY_PERIOD_REQUEST = "UPDATE_TENANCY_PERIOD_REQUEST";
export const UPDATE_TENANCY_PERIOD_SUCCESS = "UPDATE_TENANCY_PERIOD_SUCCESS";
export const UPDATE_TENANCY_PERIOD_FAIL = "UPDATE_TENANCY_PERIOD_FAIL";
export const UPDATE_PROPERTY_DETAILS_REQUEST = "UPDATE_PROPERTY_DETAILS_REQUEST";
export const UPDATE_PROPERTY_DETAILS_SUCCESS = "UPDATE_PROPERTY_DETAILS_SUCCESS";
export const UPDATE_PROPERTY_DETAILS_FAIL = "UPDATE_PROPERTY_DETAILS_FAIL";
export const DELETE_BEDROOM_REQUEST = "DELETE_BEDROOM_REQUEST";
export const DELETE_BEDROOM_SUCCESS = "DELETE_BEDROOM_SUCCESS";
export const DELETE_BEDROOM_FAIL = "DELETE_BEDROOM_FAIL";
export const ADD_BEDROOMS_REQUEST = "ADD_BEDROOMS_REQUEST";
export const ADD_BEDROOMS_SUCCESS = "ADD_BEDROOMS_SUCCESS";
export const ADD_BEDROOMS_FAIL = "ADD_BEDROOMS_FAIL";
export const UPDATE_BEDROOM_IDENTIFIER_REQUEST = "UPDATE_BEDROOM_IDENTIFIER_REQUEST";
export const UPDATE_BEDROOM_IDENTIFIER_SUCCESS = "UPDATE_BEDROOM_IDENTIFIER_SUCCESS";
export const UPDATE_BEDROOM_IDENTIFIER_FAIL = "UPDATE_BEDROOM_IDENTIFIER_FAIL";
export const UPDATE_TENANT_EMAIL_REQUEST = "UPDATE_TENANT_EMAIL_REQUEST";
export const UPDATE_TENANT_EMAIL_SUCCESS = "UPDATE_TENANT_EMAIL_SUCCESS";
export const UPDATE_TENANT_EMAIL_FAIL = "UPDATE_TENANT_EMAIL_FAIL";
export const SET_PROPERTY_LISTING_PAGE_SIZE = "SET_PROPERTY_LISTING_PAGE_SIZE";
export const GET_LISTINGS_PREFETCH_SUCCESS = "GET_LISTINGS_PREFETCH_SUCCESS";
export const GET_LISTINGS_STATS_REQUEST = "GET_LISTINGS_STATS_REQUEST";
export const GET_LISTINGS_STATS_SUCCESS = "GET_LISTINGS_STATS_SUCCESS";
export const GET_LISTINGS_STATS_FAIL = "GET_LISTINGS_STATS_FAIL";
export const INVALIDATE_LISTINGS_STATS_CACHE = "INVALIDATE_LISTINGS_STATS_CACHE";
export const GET_LISTING_DOCUMENTS_REQUEST = "GET_LISTING_DOCUMENTS_REQUEST";
export const GET_LISTING_DOCUMENTS_SUCCESS = "GET_LISTING_DOCUMENTS_SUCCESS";
export const GET_LISTING_DOCUMENTS_FAIL = "GET_LISTING_DOCUMENTS_FAIL";
export const UPLOAD_LISTING_DOCUMENT_REQUEST = "UPLOAD_LISTING_DOCUMENT_REQUEST";
export const UPLOAD_LISTING_DOCUMENT_SUCCESS = "UPLOAD_LISTING_DOCUMENT_SUCCESS";
export const UPLOAD_LISTING_DOCUMENT_FAIL = "UPLOAD_LISTING_DOCUMENT_FAIL";
export const DELETE_LISTING_DOCUMENT_SUCCESS = "DELETE_LISTING_DOCUMENT_SUCCESS";
export const DELETE_LISTING_DOCUMENT_FAIL = "DELETE_LISTING_DOCUMENT_FAIL";
export const SET_LISTING_DOCUMENT_SHARE_SUCCESS = "SET_LISTING_DOCUMENT_SHARE_SUCCESS";
export const SET_LISTING_DOCUMENT_SHARE_FAIL = "SET_LISTING_DOCUMENT_SHARE_FAIL";
export const RENAME_LISTING_DOCUMENT_SUCCESS = "RENAME_LISTING_DOCUMENT_SUCCESS";
export const RENAME_LISTING_DOCUMENT_FAIL = "RENAME_LISTING_DOCUMENT_FAIL";
